import dayjs from 'dayjs'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import duration from 'dayjs/plugin/duration'
import 'dayjs/locale/vi'

dayjs.locale('vi')
dayjs.extend(dayOfYear)
dayjs.extend(duration)
